import React, { useEffect, useState, useMemo } from "react";
import MainLayout from "../../Layout/mainLayout";
import "./listConfig.css";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { viewCountryListPagination } from "../../Redux/Actions/settingsActions";
import toast from "react-hot-toast";
// import SelectInput from "../../Global Functions/selectInput";
import { SketchPicker } from "react-color";
import MediaUploadPopup from "./mediaUploadPopup";
// import AddImage from "../../Global Functions/addImage";


const ListConfig = () => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({});
  const [editingField, setEditingField] = useState({
    setting_id: null,
    key: null,
    value: "",
  });

  const { admin } = useSelector((state) => state.admin || {});
  const { canAdd, canEdit } = useMemo(() => {
    const codes = admin?.data?.access_code || [];
    return {
      canAdd: Array.isArray(codes) && codes.includes("add"),
      canEdit: Array.isArray(codes) && codes.includes("edit"),
    };
  }, [admin]);

  const [editPopupKey, setEditPopupKey] = useState(null);
  const [colorIndex, setColorIndex] = useState(0);
  // const [mediaPopupVisible, setMediaPopupVisible] = useState(false);
  // const [uploadedPhotoUrl, setUploadedPhotoUrl] = useState("");
  // const [uploadedVideoUrl, setUploadedVideoUrl] = useState("");
  const [showPopup, setShowPopup] = useState(false);


  // const handleMediaUpload = async (event, setUrl) => {
  //   const uploadedFile = event.target.files[0];
  //   if (!uploadedFile) {
  //     toast.error("No file selected");
  //     return;
  //   }
  //   const responseUrl = await AddImage(uploadedFile);
  //   if (responseUrl) {
  //     setUrl(responseUrl);
  //     toast.success("File uploaded successfully");
  //   } else {
  //     toast.error("File upload failed");
  //   }
  // };

  const [editConfigPopup, setEditConfigPopup] = useState(false);
  // const { countryList } = useSelector((state) => state.country || {});

  const colorFields = [
    "header",
    "subHeader",
    "freebies_gradient",
    "deals_gradient",
  ];

  useEffect(() => {
    setColorIndex(0);
  }, [editPopupKey]);

  // const handleEditPopTrigger = () => {
  //   setEditConfigPopup(!editConfigPopup);
  // };

  const openEditPopup = (key) => {
    let value = formData?.data?.[key] || "";
    if (colorFields.includes(key)) {
      value = Array.isArray(value) ? [...value] : [];
    }
    setEditPopupKey(key);
    setEditingField({
      key,
      value,
      setting_id: formData?.data?._id,
    });
  };

  const closeEditPopup = () => {
    setEditPopupKey(null);
    setEditingField({ setting_id: null, key: null, value: "" });
  };

  const getConfigData = async () => {
    try {
      const responseData = await axios.get(`${BASE_URL}/setting/view`, {
        headers: { "Content-Type": "application/json" },
      });

      if (responseData.data && responseData.data.data) {
        const data = responseData.data.data;

        setFormData(responseData.data);
      }
    } catch (error) {
      console.error("Error fetching config data:", error);
    }
  };

  useEffect(() => {
    getConfigData();
  }, []);

  const editConfigHandler = async (payload) => {
    try {
      if (payload) {
        const response = await axios.post(
          `${BASE_URL}/setting/update`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        return response.data;
      }
    } catch (error) {
      console.log(error);
    }
  };

  const saveConfiguration = async () => {
    const { key, value, setting_id } = editingField;

    let finalValue = value;
    if (colorFields.includes(key)) {
      finalValue = Array.isArray(value) ? value : [];
      finalValue = finalValue.filter((str) => str.length > 0);
    } else if (
      ["header", "subHeader", "freebies_gradient", "deals_gradient"].includes(key)
    ) {
      finalValue = value
        .split(",")
        .map((str) => str.trim())
        .filter((str) => str.length > 0);
    }

    const payload = {
      setting_id,
      [key]: finalValue,
    };

    const response = await editConfigHandler(payload);
    if (response?.statusCode === 200) {
      toast.success("Edited Successfully!!");
      setEditPopupKey(null);
      setEditingField({ setting_id: null, key: null, value: "" });
      getConfigData();
    } else {
      toast.error("Failed to update configuration.");
    }
  };


  const handleInputChange = (event) => {
    setEditingField((prevData) => ({
      ...prevData,
      value: event.target.value,
    }));
  };

  const handleColorChange = (color, index) => {
    setEditingField((prev) => {
      const colors = Array.isArray(prev.value)
        ? [...prev.value]
        : [];
      colors[index] = color.hex;
      return { ...prev, value: colors };
    });
  };

  useEffect(() => {
    if (editConfigPopup) {
      dispatch(viewCountryListPagination());
    }
  }, [editConfigPopup, dispatch]);

  const formatLabel = (key) => {
    return key
      .replace(/_/g, " ")
      .replace(
        /\w\S*/g,
        (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
      );
  };

  return (
    <MainLayout>
      <div className="config_container_top">
        <div className="config-heading">
          <h2 className="h2_config_head" >Configuration</h2>
        </div>
        <div className="popup-box">
          {/* <button className="button-class" style={{background: "#0D152B"}} onClick={() => setMediaPopupVisible(true)}>
            Upload Media
          </button>
          {mediaPopupVisible && (
            <div className="popup-overlay">
              <div className="popup-modal">
                <h3>Upload Media</h3>

                <div>
                  <label>Upload Photo:</label>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => handleMediaUpload(e, setUploadedPhotoUrl)}
                  />
                  {uploadedPhotoUrl && (
                    <p>
                      Photo URL:{" "}
                      <a href={uploadedPhotoUrl} target="_blank" rel="noreferrer">
                        {uploadedPhotoUrl}
                      </a>
                    </p>
                  )}
                </div>

                <div style={{ marginTop: "20px" }}>
                  <label>Upload Video:</label>
                  <input
                    type="file"
                    accept="video/*"
                    onChange={(e) => handleMediaUpload(e, setUploadedVideoUrl)}
                  />
                  {uploadedVideoUrl && (
                    <p>
                      Video URL:{" "}
                      <a href={uploadedVideoUrl} target="_blank" rel="noreferrer">
                        {uploadedVideoUrl}
                      </a>
                    </p>
                  )}
                </div>

                <div style={{ marginTop: "20px" }}>
                  <button onClick={() => setMediaPopupVisible(false)}>Close</button>
                </div>
              </div>
            </div>
          )} */}
          <button className="button-class" style={{ background: "#0D152B" }} onClick={() => setShowPopup(true)}>
            Upload Media
          </button>
          <MediaUploadPopup visible={showPopup} onClose={() => setShowPopup(false)} />

        </div>
        <div className="config_container">
          {/* General settings */}
          {formData.data &&
            Object.entries(formData.data).map(([key, val], index) => {
              const excludedFields = [
                "_id",
                "is_deleted",
                "created_by",
                "created_at",
                "updated_at",
                "countries",
                "comming_soon_cities",
              ];
              if (excludedFields.includes(key) || typeof val === "object") {
                if (colorFields.includes(key)) {
                  const displayValue = Array.isArray(val) ? val.join(", ") : "";
                  return (
                    <div key={index} className="input-wrapper-lc">
                      <label className="input-label">{formatLabel(key)}</label>
                      <div className="input-container">
                        <input className="input-box" value={displayValue} readOnly />
                        {canEdit && (
                          <button className="edit-button" onClick={() => openEditPopup(key)}>
                            Edit
                          </button>
                        )}
                      </div>
                    </div>
                  );
                }
                return null;
              }
              return (
                <div key={index} className="input-wrapper-lc">
                  <label className="input-label">{formatLabel(key)}</label>
                  <div className="input-container">
                    <input className="input-box" value={val} readOnly />
                    {canEdit && (
                      <button
                        className="edit-button"
                        onClick={() => openEditPopup(key)}
                      >
                        Edit
                      </button>
                    )}
                  </div>
                </div>
              );
            })}

          {/* Countries section */}
          {/* {formData.data?.countries && (
            <div className="countries-container">
              <div className="countries-div">
                <h3>Countries</h3>
                <div>
                  <a href="/config/add" className="edit-button">
                    Add Country
                  </a>
                  <button onClick={handleEditPopTrigger} className="edit-button">
                    Edit Country
                  </button>
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <div className="card-wrapper">
                  {formData.data.countries.map((country, idx) => (
                    <div key={country._id || idx} className="country-card">
                      <span className="country-name">{country.name}</span>
                      <span>
                        <strong>Currency:</strong> {country.currency}
                      </span>
                      <span>
                        <strong>Tax:</strong> {country.tax}%
                      </span>
                      <span>
                        <strong>Booking %:</strong>{" "}
                        {country.booking_amount_percent * 100}%
                      </span>
                      <span>
                        <strong>Min Booking:</strong>{" "}
                        {country.min_booking_amount || country.min_boking_amount}
                      </span>
                      <span>
                        <strong>Max Booking:</strong> {country.max_booking_amount}
                      </span>
                    </div>
                  ))}
                </div>

                {editConfigPopup && (
                  <div
                    className="popup-overlay"
                    style={{
                      display: "grid",
                      border: "1px solid #d1d1d1d1",
                      gridTemplateColumns: "repeat(2,1fr)",
                    }}
                  >
                    <div className="config_container_add popup-modal">
                      <div>
                        <SelectInput
                          placeholder="Select an Option"
                          label="Select Country"
                          options={
                            Array.isArray(countryList?.data)
                              ? countryList.data.map((country) => ({
                                value: country._id,
                                label: country.country_name,
                              }))
                              : []
                          }
                          onChange={(event) => {
                            const selectedId = event.target.value;
                            const selectedCountry = countryList?.data?.find(
                              (country) => country._id === selectedId
                            );
                            if (!selectedCountry) return;
                            setEditState((prevState) => {
                              const countries = [...prevState.countries];
                              countries[0] = {
                                ...countries[0],
                                name: selectedCountry.country_name,
                                _id: selectedCountry._id,
                              };
                              return { ...prevState, countries };
                            });
                          }}
                        />
                      </div>
                      <div>
                        <TextInput
                          label="Tax Rate"
                          placeholder="Enter..."
                          onChange={(e) =>
                            setEditState((prev) => {
                              const countries = [...prev.countries];
                              countries[0].tax = e.target.value;
                              return { ...prev, countries };
                            })
                          }
                        />
                      </div>
                      <div>
                        <TextInput
                          label="Currency"
                          placeholder="Enter..."
                          onChange={(e) =>
                            setEditState((prev) => {
                              const countries = [...prev.countries];
                              countries[0].currency = e.target.value;
                              return { ...prev, countries };
                            })
                          }
                        />
                      </div>
                      <div>
                        <TextInput
                          label="Booking Amount"
                          placeholder="Enter..."
                          onChange={(e) =>
                            setEditState((prev) => {
                              const countries = [...prev.countries];
                              countries[0].booking_amount = e.target.value;
                              return { ...prev, countries };
                            })
                          }
                        />
                      </div>
                      <button
                        onClick={() => setEditConfigPopup(false)}
                        className="button-class-white"
                      >
                        Cancel
                      </button>
                      <button
                        onClick={() => editConfigHandler(editState)}
                        className="button-class-white"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )} */}

          {/* Coming Soon Cities section */}
          {/* {formData.data?.comming_soon_cities && (
            <div className="countries-container">
              <div className="countries-div">
                <h3>Coming Soon Cities</h3>
                <div>
                  {canAdd && (
                    <button
                      className="edit-button"
                      style={{ fontWeight: "600" }}
                      onClick={(e) => {
                        e.preventDefault();
                        setShowAddCityPopup(true);
                      }}
                      disabled={citiesLoading}
                    >
                      {citiesLoading ? "Adding..." : "Add City"}
                    </button>
                  )}

                  {canEdit && (
                    <button
                      onClick={openEditCitiesPopup}
                      className="edit-button"
                    >
                      Edit Cities
                    </button>
                  )}
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <div className="card-wrapper">
                  {formData.data.comming_soon_cities.map((city, idx) => (
                    <div key={city._id || idx} className="country-card">
                      <span className="country-name">{city.name}</span>
                      <span className="description tooltip-rect">
                        <strong>Description:-</strong>{city.description?.slice(0, 100)}{city.description?.length > 100 ? "..." : ""}

                        <span className="tooltip-box">{city.description}</span>
                      </span>
                      {city.url && (
                        <img
                          src={city.url}
                          alt={city.name}
                          style={{
                            width: "100px",
                            height: "80px",
                            objectFit: "cover",
                            borderRadius: "5px",
                            marginTop: "5px",
                          }}
                        />
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )} */}
        </div>
      </div>

      {/* Generic edit popup */}
      {editPopupKey && (
        <div className="popup-overlay">
          <div className="popup-modal">
            <h3>
              Edit: {editingField.key} (Color {colorIndex + 1} of{" "}
              {Array.isArray(editingField.value) ? editingField.value.length : 0})
            </h3>

            {colorFields.includes(editingField.key) ? (
              Array.isArray(editingField.value) && editingField.value.length > 0 ? (
                <>
                  <SketchPicker
                    color={editingField.value[colorIndex]}
                    onChangeComplete={(color) => handleColorChange(color, colorIndex)}
                  />
                  <div
                    style={{
                      marginTop: "10px",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <button
                      onClick={() =>
                        setColorIndex((prev) => (prev > 0 ? prev - 1 : prev))
                      }
                      disabled={colorIndex === 0}
                    >
                      Previous
                    </button>
                    <button
                      onClick={() =>
                        setColorIndex((prev) =>
                          prev < editingField.value.length - 1 ? prev + 1 : prev
                        )
                      }
                      disabled={
                        colorIndex ===
                        (Array.isArray(editingField.value)
                          ? editingField.value.length - 1
                          : 0)
                      }
                    >
                      Next
                    </button>
                  </div>
                </>
              ) : (
                <span>Loading colors...</span>
              )
            ) : (
              <input
                type="text"
                className="modal-input-config"
                value={editingField.value}
                onChange={handleInputChange}
              />
            )}

            <div className="modal-buttons">
              <button onClick={closeEditPopup}>Cancel</button>
              <button onClick={saveConfiguration}>Save</button>
            </div>
          </div>
        </div>
      )}
    </MainLayout>
  );
};

export default ListConfig;
